<template>
  <div>
    <router-view :organizations="organizations" :viewingEvents="viewingEvents" :isEmptyCartPhotos="isEmptyCartPhotos" @fetchOrganization="fetchOrganization"></router-view>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import Organization from 'processor/Organization'
  import Event from 'processor/Event'
  import Cart from 'processor/Cart'

  /** @name page_subPages_MyPage_Event */
  export default {
    name:"",
    components: {
    },
    data () {
      return {
        viewingEvents:[],
        organizations:[],
        cart:{},
        cartPhotos:[],
        isShowShoolCodePopoverForm:false
      }
    },
    created(){
    },
    mounted(){
      this.fetchOrganization()
    },
    beforeRouteUpdate (to, from, next) {
      this.fetchOrganization()
      next()
    },
    computed:{
      isEmptyCartPhotos(){
          return this.cartPhotos.length <= 0
      }
    },
    methods:{
      fetchOrganization(){
        Organization.gets({with_events:1})
          .then((res)=>{
            if(res.status === "ng"){
              this.apiErrorI18nKeyByOrganization = res.apiErrorI18nKey
              return
            }
            this.organizations = res.data.organizations
          })
        Event.getViewingEvents()
          .then((res)=>{
            if(res.status === "ng"){
              this.apiErrorI18nKeyByViewingEvent = res.apiErrorI18nKey
              return
            }
            this.viewingEvents = res.data.events
          })
        Cart.cartPreparation()
          .then((res)=>{
            if(res.status === "ng"){
              this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
              return
            }
            this.cart = res.data.cart
          }).then(()=>{
            Cart.getCartPhotos({cart_id:this.cart.id})
              .then((res)=> {
                if (res.status === "ng") {
                  this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
                  return
                }
                this.cartPhotos = res.data.cart_photos
              })
            })
      },
    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Event.vue?0e752387